<template>
  <div class="modal fade" id="add_update_res_story_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="add_update_res_story_modalLabel">Add / Delete Restaurant Stories</h4>
        </div>

        <div class="modal-body">
          <form id="storyForm" method="post" @submit.prevent="addUpdateCategory()" enctype="multipart/form-data">
            <div class="row">
              <div class="col-lg-5">
                <div class="form-group">
                  <label>Name</label>
                  <select required="required" class="form-control" v-model="type">
                    <option value="" disabled selected>Select Media Type</option>
                    <option value="image">Image</option>
                    <option value="video">Video</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-5">
                <div class="form-group">
                  <label>Story Media</label><br/>
                  <input v-on:change="handlePicture()" required id="story-media" type="file" class="form-control image" placeholder="Type...">
                </div>
              </div>
              <div class="col-lg-2">
                <div class="form-group">
                  <button class="btn btn-primary btn-xs" style="margin-top: 25px;margin-right: 5px" type="submit"><i :class=" 'fa fa-plus'" ></i></button>
                </div>
              </div>
            </div>
            <div class="row">

              <div class="form-group">
                <div class="progress"
                     id="progress"
                     style="display: none"
                >
                  <div id="progress-bar"
                       class="progress-bar progress-bar-info progress-bar-striped active"
                       role="progressbar"
                       :style="{width: uploadImagePercentage+'%'}"
                       :aria-valuenow="uploadImagePercentage"
                       aria-valuemin="0"
                       aria-valuemax="100"
                  >
                    {{uploadImagePercentage}}%
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="row">
            <div class="col-lg-12">
              <div v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                <div class="sk-bounce1"></div>
                <div class="sk-bounce2"></div>
                <div class="sk-bounce3"></div>
              </div>
            </div>
          </div>

          <div class="table-responsive" style="overflow: auto">
            <table class="table table-striped table-bordered table-hover responsive" id="dtTable">
              <thead>
              <tr>
                <th>Image</th>
                <th>Type</th>
                <th>Delete</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="story in stories" :key="story.id" >
                <td>
                  <img v-if="story.type === 'image'" v-bind:src="story.storyUrl" alt="No image found" style="max-width: 20% ;max-height: 20%">
                  <video v-else style="max-width: 20%; max-height: 20%;" controls autoplay>
                    <source :src="story.storyUrl" type="video/mp4">
                  </video>
                </td>
                <td>{{ story.type }}</td>
                <td>&emsp;<a href="javascript:void(0)" style="color: inherit;"><i v-on:click="deleteStory(story.id)" class="fa fa-trash"></i></a></td>
              </tr>

              </tbody>
            </table>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
/* eslint-disable */
export default {
  name: "AddRestaurantStories",
  data() {
    return {
      category: {
        "id": 0,
        "name": "",
      },
      type: "",
      restaurantId: 0,
      update:false,
      image: null,
      categories:[],
      stories:[],
      isHideSpinner:"",
      uploadImagePercentage: 0,
    }
  },
  mounted: function () {
    $('#add_update_res_story_modal').on('hidden.bs.modal',  (e) => {
      this.resetData();
    });
  },
  methods: {
    setProgressBarStyle: function (display){
      this.uploadingItems = (display === 'flex');
      document.getElementById("progress").style.display = display;
      this.uploadImagePercentage = 0;
    },
    load (restaurantId){
      if (restaurantId) {
        this.restaurantId = restaurantId
      }
      this.isHideSpinner = "";
      this.fetchStories();
      $("#add_update_res_story_modal").modal("show");
    },
    fetchStories() {
      try {
        this.$http.get(this.$store.state.mainAppURL + `restaurant_story/${this.restaurantId}`).then(resp => {
          console.log(resp.status)
          if(resp.status === 200) {
            this.isHideSpinner = "hide";
            this.stories = resp.data.body;
          } else {
            this.isHideSpinner = "hide";
          }
        });
      } catch (e) {
        this.isHideSpinner = "hide";
      }
    },
    handlePicture: function() {
      let input =$("#story-media");
      if (input.prop('files')[0] !== undefined) {
        var reader = new FileReader();
        reader.onload = function(e) {
          input.prev().attr('src', e.target.result);
        };
        reader.readAsDataURL(input.prop('files')[0]);
        this.image = input.prop('files')[0];
      }else{
        input.prev().attr('src', "");
      }

    },
    async deleteStory (id) {
      let self = this;
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to delete the story?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async result => {
        if (result.value) {
          this.showLoading()
          await this.$http.delete(this.$store.state.mainAppURL + `restaurant_story/${id}`).then(resp => {
            if (resp.status === 200) {
              swal("Deleted Successfully", "success");
            } else {
              swal(resp.data.message, "error");
            }
          });
          this.fetchStories();
        }
      }).catch(ex => swal("Error!" ," Unable To Delete", "error"));
    },
    addUpdateCategory: function () {
      let formData = new FormData();
      formData.append("type", this.type);
      formData.append("story_media", this.image);
      formData.append("restaurant_id", this.restaurantId);
      this.setProgressBarStyle("flex");
      let self = this;
      this.$http.post( this.$store.state.mainAppURL + "restaurant_story/",
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data;'
            },
            onUploadProgress: function (progressEvent) {
              if (progressEvent.lengthComputable) {
                self.uploadImagePercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              }
            }.bind(self)
          }
      ).then((resp) => {
        console.log(resp);
        Swal.close();
        if(resp.data){
          swal("Saved Successfully", "success");
          this.setProgressBarStyle("none");
          this.load();
          this.image = "";
          $('#storyForm')[0].reset();
          $('#story-media').val('');
        }else{
          this.showErrorMessage("Try Again!")
        }
      }).catch((ex) => {
        this.setProgressBarStyle("none");
        this.showErrorMessage(ex)
      });
      this.fetchStories();
      this.resetFile();
    },
    resetFile() {
      $("input[type=file]").val("");
      $(".bigPic").prev().attr("src", "");
      $(".smallPic").prev().attr("src", "");
      this.type = '';
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this));
      $("input[type=file]").val("");
      $(".bigPic").prev().attr("src", "");
      $(".smallPic").prev().attr("src", "");
    }
  }
}
</script>

<style scoped>

</style>
